import http from './Api';

class InsightsApi {
  static getSubscriptionsMonthsByRange(start, end) {
    return http.get(`insights/subscriptions/year-month-overview?from=${start}&to=${end}`);
  }

  static getSubscriptionsListByMonth(params) {
    return http.get(`insights/subscriptions/renewal-collections-overview`, { params });
  }
}

export default InsightsApi;
